<template>
  <ul class="gap-y-2 list-inside">
    <li v-for="(item, index) in items" :key="index" class="flex">
      <slot name="item" :item="item" :index="index">
        <span class="px-3">&bull;</span><span class="text-gray-700">{{ item }}</span>
      </slot>
    </li>
  </ul>
</template>

<script lang="ts" setup generic="T = string">
 interface Props {
  items?: T[]
 }

withDefaults(defineProps<Props>(), {
  items: () => [],
})
</script>
